import { compose } from 'redux';
import { ObjectShim } from '@packages/helpers/core/shims/object-shim';
import { GEO_LOCATION_REGIONS } from '../constants';
import { mapDepositAmount, mapTotalCosts } from '../user-attributes/map-user-attributes';

export const mapCostsBreakdownConfig = compose(mapDepositAmount, mapTotalCosts);

const parseLocation = (location = {}) => {
  const { isEngland, isWales, isScotland, isNorthernIreland } = location;

  if (isEngland) {
    return GEO_LOCATION_REGIONS.ENGLAND;
  }

  if (isScotland) {
    return GEO_LOCATION_REGIONS.SCOTLAND;
  }

  if (isWales) {
    return GEO_LOCATION_REGIONS.WALES;
  }

  if (isNorthernIreland) {
    return GEO_LOCATION_REGIONS.NI;
  }

  return GEO_LOCATION_REGIONS.LONDON;
};

export const mapCost = ({ attrKey, dataKey, goals, configuration }) => {
  return { value: goals[attrKey], ...ObjectShim.getNested(configuration, dataKey) };
};

export const mapStampDutyCost = ({ goalsLocationParsed, ...goals }, configuration) => {
  const locationKey = parseLocation(goalsLocationParsed);

  return mapCost({ attrKey: 'stampDuty', dataKey: `stampDutyExplained.${locationKey}`, goals, configuration });
};
